import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS } from 'mobx';
import { observer } from 'mobx-react'

import Cropper from 'react-cropper';


import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';


@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class Crop extends Component {


  @observable imgPath = "";
  @observable showCrop = false;
  @observable animateClass = '';

  cropParams = {
    x : 0,
    y : 0,
    h : 0,
    w : 0
  }

  constructor(props) {

    super(props);

    this.trans = this.props.dictionaryStorage.getCurrentLangDict;

    let scope = this;

    $(window).on('resize',()=>{

    })

    $(window).on('bf-transform', (e,obj)=> {
      if ( obj == 'crop-image' )
      {

        var active = bf_project.getActiveLayer();

        if ( active == null ) return;

        $(window).trigger('ShowLoader');


        this.showCrop = true;

        this.imgPath = active.path;

        let img = new Image();
        img.src = active.path;
        img.onload = ()=>{

          $(window).trigger('HideLoader');
        }

        img.onerror = ()=>{
          $(window).trigger('HideLoader');
          this.showCrop = false;
        }


        setTimeout(()=>{
          this.animateClass = 'Crop-animation';
        },100)

      }
    })

  }

  _crop(e){

    this.cropParams.x = Math.round( e.detail.x );
    this.cropParams.y = Math.round( e.detail.y );
    this.cropParams.w = Math.round( e.detail.width );
    this.cropParams.h = Math.round( e.detail.height );
    // image in dataUrl
  //  console.log(this.refs.cropper.getCroppedCanvas().toDataURL());
  }

  cropmove(e) {

  }

  doCancel(){
      this.animateClass = '';
      setTimeout(()=>{
        this.showCrop = false;
      },700)
  }

  doCrop(){
    var active = bf_project.getActiveLayer();

    if ( active == null ) return;

    $.ajax({
      // cache: false,
      headers: {
        'x-client-id': bf_config.clientID
      },
      url:  bf_config.api + 'images/'+ active.idImg +'/crop',
      dataType: "json",
      data : toJS( this.cropParams),
      method : "post",
      success: (data)=>
      {
        $(window).trigger('Crop-setCropToActiveLayer',data);

        this.animateClass = '';
        setTimeout(()=>{
          this.showCrop = false;
        },700)

      },
      error:(data)=>
      {
        // console.log(data);
      }
    });
  }

  render() {

    const trans = this.trans;
    const t = this.t;


    return (
      <div className="Crop" >
        {
        this.showCrop
        &&
        <div className={"Crop-container "+this.animateClass}>
          <div>
              <Cropper
                ref='cropper'
                src={this.imgPath}
                style={{height: '100%', width: '100%'}}
                responsive={true}
                scalable={true}
                guides={false}
                zoomable={false}
                crop={this._crop.bind(this)} />

              <div className="Crop-actions">
                <button className="btn_save_crop" onClick={()=>{this.doCancel()}}>
                  <span>{t('Cancel')}<i className="fa fa-close" aria-hidden="true"></i></span>
                  <span></span>
                </button>

                <button className="btn_save_crop" onClick={()=>{this.doCrop()}}>
                  <span>{t('Save crop')}<i className="fa fa-angle-right" aria-hidden="true"></i></span>
                  <span>{t('Processing')} <span className="small-loader"><span></span></span></span>
                </button>
              </div>
            </div>
        </div>
        }
      </div>
    );
  }
}

/*
 <div id="bf-crop-area"></div>

 js-save_crop
 js-cancel_crop

 */




